import { getProducts, GetOfficeSuppliesApiParameter } from "@GeriMed/Services/OfficeSuppliesService";
import { CustomerDisplayProductCollection } from "@GeriMed/Type/ApiModelsExt";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";


type HandlerType = ApiHandler<GetOfficeSuppliesApiParameter, CustomerDisplayProductCollection>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const DispatchBeginLoadOfficeSuppliesList: HandlerType = props => {
    props.dispatch({
        type: "Data/OfficeSupplies/BeginLoadOfficeSupplies" as any,
        parameter: props.parameter,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getProducts(props.apiParameter);
};
export const DispatchCompleteLoadOfficeSuppliesList: HandlerType = props => {
    props.dispatch({
        type: "Data/OfficeSupplies/CompleteLoadOfficeSupplies" as any,
        collection: props.apiResult,
        parameter: props.parameter,
    });
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadOfficeSuppliesList,
    RequestDataFromApi,
    DispatchCompleteLoadOfficeSuppliesList,
];

const loadOfficeSuppliesList = createHandlerChainRunner(chain, "loadOfficeSuppliesList");
export default loadOfficeSuppliesList;
